// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBcDYteCY8MDMuEt-1ENShX3GdoPHONGI0",
  authDomain: "cfb-scores-vibe.firebaseapp.com",
  projectId: "cfb-scores-vibe",
  storageBucket: "cfb-scores-vibe.firebasestorage.app",
  messagingSenderId: "599561411612",
  appId: "1:599561411612:web:b0f6bdacf5257898f393d9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// VAPID Key for Firebase Cloud Messaging
const VAPID_KEY = "BHkHi9gkAYIHlO1d4pnIP4K0vlqFhTYu95nHXuZy33Fo8ngDJgvOslEQ8oZ9ol0ZNFqY_NreCsZlRyy4mYrOQpg";

// Initialize Firebase Cloud Messaging
let messaging = null;

try {
  messaging = getMessaging(app);
} catch (error) {
  console.error('Failed to initialize Firebase Messaging:', error);
}

export { app, messaging, VAPID_KEY };

// Helper functions for FCM token management
export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications.');
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    console.log('Notification permission granted.');
    return true;
  } else {
    console.log('Unable to get permission to notify.');
    return false;
  }
}

export async function getFCMToken() {
  if (!messaging) {
    console.error('Firebase messaging not initialized');
    return null;
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: VAPID_KEY
    });

    if (currentToken) {
      console.log('FCM Token:', currentToken);
      return currentToken;
    } else {
      console.log('No registration token available. Request permission to generate one.');
      return null;
    }
  } catch (error) {
    console.error('An error occurred while retrieving token. ', error);
    return null;
  }
}

export function onFCMMessage(callback) {
  if (!messaging) {
    console.error('Firebase messaging not initialized');
    return null;
  }

  return onMessage(messaging, callback);
}